
const webwebVd = {

    variantDrawer: undefined,
    main: undefined,
    header: undefined, 

    init() {
        this.overlayBackground = document.querySelector('.overlay-bg');
        this.variantDrawer = document.getElementById('product-variant-drawer');
        this.header = document.querySelector('.header-wrapper');
        this.main = document.querySelector('main');

        if (this.variantDrawer) document.body.appendChild(this.variantDrawer);
        this.addEventListeners();
    },

    addEventListeners() {
        if (this.overlayBackground) {
            this.overlayBackground.addEventListener('transitionend', () => {
                if (!this.overlayBackground.classList.contains('active')) {
                    this.overlayBackground.classList.remove('visible');
                }
            });
            this.overlayBackground.addEventListener('click', () => {
                this.hideDrawer();
            });
        }

        if (this.variantDrawer) {
            const close = this.variantDrawer.querySelector('.product-variant-drawer__close');
            if (close) {
                close.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    this.hideDrawer();
                })
            }
        }

        document.querySelectorAll('.button--variant-select').forEach(button => {
            button.addEventListener('click', (ev) => {
                this.showDrawer();
                ev.preventDefault();
            });
        });   
    },

    showDrawer() {
        if (this.variantDrawer) this.variantDrawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
        this.showOverlayBackground();
    },

    hideDrawer() {
        if (this.variantDrawer) this.variantDrawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        this.hideOverlayBackground();
    },

    showOverlayBackground() {
        if (this.main) this.main.classList.add('blur');
        if (this.header) this.header.classList.add('blur');
        if (this.overlayBackground) {
            this.overlayBackground.classList.add('visible');
            setTimeout(() => { this.overlayBackground.classList.add('active') }, 1);
        }
    },

    hideOverlayBackground() {
        if (this.main) this.main.classList.remove('blur');
        if (this.header) this.header.classList.remove('blur');
        if (this.overlayBackground) {
            this.overlayBackground.classList.remove('active');
        }
    }
}

document.addEventListener('DOMContentLoaded', (e) => {
    webwebVd.init();
});
